import { ObservationsParams } from './types'
import { useDeleteObservation } from './useDeleteObservation'
import { useFetchObservations } from './useFetchObservations'

type Props = { params: ObservationsParams }

export const useObservations = ({ params }: Props) => {
  const {
    observations,
    isFetching,
    loadObservations,
    addObservation,
    removeObservation,
    updateObservation,
  } = useFetchObservations(params)
  const { deleteObservation, isDeleting } = useDeleteObservation()

  const hasMore = observations
    ? observations.results.length < observations.count
    : true
  const loadMore = () => !isFetching && loadObservations()

  return {
    observations,
    isFetching,
    isDeleting,
    hasMore,
    loadObservations,
    loadMore,
    addObservation,
    removeObservation,
    updateObservation,
    deleteObservation,
  }
}
